const SIGNUP_ORG_NAME_KEY = 'w86_signup_org_name';

export function saveSignupOrgName(orgName) {
  const trimmed = (orgName || '').trim();
  if (!trimmed) {
    localStorage.removeItem(SIGNUP_ORG_NAME_KEY);
    return;
  }
  localStorage.setItem(SIGNUP_ORG_NAME_KEY, trimmed);
}

export function readSignupOrgName() {
  return (localStorage.getItem(SIGNUP_ORG_NAME_KEY) || '').trim();
}

export function clearSignupOrgName() {
  localStorage.removeItem(SIGNUP_ORG_NAME_KEY);
}
